import axios from "axios";
import qs from 'qs'
import $store from "../store"

// 接口地址支持发布后配置，避免把旧域名或虚拟机 IP 固定编译进代码。
// 未配置时默认使用当前站点的 /api/v1/，适合前后台部署在同一域名的环境。
const runtimeConfig = window.__FOOTBALL_RESEARCH_CONFIG__ || {}
const currentOrigin = window.location.origin
let baseUrl = (runtimeConfig.assetBaseUrl || runtimeConfig.apiOrigin || currentOrigin).replace(/\/$/, '')
let baseAPIUrl = runtimeConfig.apiBaseUrl || ((runtimeConfig.apiOrigin || currentOrigin).replace(/\/$/, '') + '/api/v1/')
if (!/\/$/.test(baseAPIUrl)) baseAPIUrl += '/'
const hasManualApi = Boolean(runtimeConfig.apiBaseUrl || runtimeConfig.apiOrigin)
let apiDiscovery = null

function normalizeApiUrl(url){
    return url.replace(/\/$/, '') + '/'
}

function getApiCandidates(){
    const protocol = window.location.protocol === 'https:' ? 'https:' : 'http:'
    const hostname = window.location.hostname
    const candidates = [baseAPIUrl]
    const cachedApi = window.localStorage.getItem('football_research_api_base')
    if (cachedApi) candidates.unshift(cachedApi)
    const configured = runtimeConfig.apiCandidates || []
    configured.forEach(url => candidates.push(url))

    // 兼容本项目历史部署使用过的 Django/IIS 端口。
    const likelyPorts = [8065, 8067, 8068, 8069, 8070, 8020, 8002, 8000, 8080, 8081, 8094, 8099]
    likelyPorts.forEach(port => {
        candidates.push(protocol + '//' + hostname + ':' + port + '/api/v1/')
    })
    candidates.push(protocol + '//' + hostname + '/api/v1/')

    // 用户在虚拟机内部打开网站时，后台也可能只绑定在回环地址。
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
        likelyPorts.forEach(port => {
            candidates.push('http://127.0.0.1:' + port + '/api/v1/')
        })
    }
    return [...new Set(candidates.map(normalizeApiUrl))]
}

function discoverApi(){
    if (hasManualApi || runtimeConfig.autoDetect === false) {
        axios.defaults.baseURL = baseAPIUrl
        return Promise.resolve(baseAPIUrl)
    }
    if (apiDiscovery) return apiDiscovery

    const candidates = getApiCandidates()
    apiDiscovery = new Promise((resolve, reject) => {
        let pending = candidates.length
        let completed = false
        candidates.forEach(candidate => {
            axios.post(candidate + 'home', qs.stringify({page: 1}), {
                timeout: 3500,
                withCredentials: false,
                headers: {'Content-Type': 'application/x-www-form-urlencoded'}
            }).then(response => {
                const payload = response.data
                if (!completed && payload && typeof payload === 'object' && ('code' in payload || 'data' in payload)) {
                    completed = true
                    baseAPIUrl = candidate
                    baseUrl = (runtimeConfig.assetBaseUrl || candidate.replace(/\/api\/v1\/$/, '')).replace(/\/$/, '')
                    axios.defaults.baseURL = candidate
                    window.localStorage.setItem('football_research_api_base', candidate)
                    resolve(candidate)
                }
            }).catch(() => {}).finally(() => {
                pending--
                if (!completed && pending === 0) {
                    apiDiscovery = null
                    reject(new Error('未找到可用的后台接口'))
                }
            })
        })
    })
    return apiDiscovery
}
axios.defaults.timeout = 50000
axios.defaults.baseURL = baseAPIUrl
axios.defaults.withCredentials = false

//axios.defaults.headers.get['Content-Type'] = 'application/x-www-form-urlencoded'  //配置请求头数据格式
//axios.defaults.headers.post['Content-Type'] = 'application/json'  //配置请求头数据格式
//axios.defaults.headers['token'] = $store.state.token

/*
axios.interceptors.response.use(response =>{
    if(response.data.code = 2){
        //router.push()
    }
})
*/
export function get_config_text(){
    return {
        title:  ' | 亚讯体育·专业赛事数据与专家贴士'
    }
}

export function api_url(){
    return {
        get imgBaseUrl(){ return baseUrl },
        home: 'home',
        recommend_list: 'recommend/list',
        recommend_more: 'recommend/more',
        recommend_view: 'recommend/view',
        login: 'authen/login',
        register: 'authen/register',

        match_list: 'match/list',
        score_list: 'score/list',
        rank_list: 'rank/list',
        member_list: 'member/list',
        member_info: 'member/info',
        // member_recommend: 'member/recommend',
        member_rate: 'member/rate',

        news_list: 'news/list',
        news_info: 'news/detail',

        sign: 'common/sign',
        match_publish: 'common/match_publish',
        match_get: 'common/match_get',
        recommend_subscribe: 'common/subscribe',
        getnotice: 'common/getnotice',
        addfollow: 'common/addfollow',
        unaddfollow: 'common/unaddfollow',

        memberinfo: 'common/member/info',
        update_info: 'common/member/update_info',
        update_pwd: 'common/member/update_pwd',
        update_portrait: 'common/member/update_portrait',
        mysubscribe: 'common/member/subscribe',
        mysubscribe_del: 'common/member/subscribe-delete',
        myrecommend: 'common/member/recommend',
        myrecommend_user: 'common/member/recommend/subscribe_list',
        myrecommend_del: 'common/member/recommend-delete',
        mycost: 'common/member/cost',
        myfollow: 'common/member/follow',
        mycost_del: 'common/member/cost-delete',
        mywithdraw: 'common/member/withdraw',
        mywithdraw_list: 'common/member/withdraw_list',
        mywithdraw_submit: 'common/member/withdraw_submit',
        myrechange_submit: 'common/member/rechange_submit',
        mynotice: 'common/member/notice',
    }
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params = {}){
    let that = this
    return new Promise((resolve, reject) => {
        let token = that.$store.state.token
        // if(token === null || token === '' || token === undefined){
        //     that.$store.commit('SHOW_LOGINPOP')
        //     return
        // }
        axios.defaults.headers['token'] = token  //token放在此处意味着可以实时读取最新的
        discoverApi().then(() => axios.post(url, qs.stringify(params))).then(response => {
            // console.log(response.data)
            // console.log(that.$router)
            if(response.data.code === 1002){
                that.$store.commit('SHOW_LOGINPOP')
            }
            // else
                resolve(response.data)
        }, err=>{
            that.$toast.fail('request fail~')
            reject(err)
        })
    })
}
/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params = {}){
    return new Promise((resolve, reject) => {
        axios.defaults.headers['token'] = $store.state.token  //token放在此处意味着可以实时读取最新的
        discoverApi().then(() => axios.get(url, {params:params})).then(response => {
            resolve(response.data)
        }, err=>{
            reject(err)
        })
    })
}
